export enum OnlineReportGroupType {
  Color,
  HealthVariant,
  Ability,
}
